import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { vasApiUrl } from "../constants/url-constants";
import { getDeviceType } from "../utils/helpers/get-device-type";

const BASE_API_URL = `${vasApiUrl()}`;

export default createScopedApi(BASE_API_URL, axiosInstance, {
    SOURCE: getDeviceType()
});
